<form [formGroup]="form" (ngSubmit)="onEmployeeFormSubmit()">
    <div class="row mb-1">
        <div class="col-md-4 col-lg-2 col-sm-12 mb-1">
            <label class="form-label">First name</label>
            <app-formcontrol
                [a-formcontrol]="form.controls.firstName"
                [a-formcontrol-name]="'firstName'"
                [a-validation-messages]="[{validationName: 'required', validationMessage: 'First name is required'}]"
            ></app-formcontrol>
        </div>
    </div>
    <div class="row mb-1">
        <div class="col-md-4 col-lg-2 col-sm-12 mb-1">
            <label class="form-label">Last name</label>
            <app-formcontrol
                [a-formcontrol]="form.controls.lastName"
                [a-formcontrol-name]="'lastName'"
                [a-validation-messages]="[{validationName: 'required', validationMessage: 'Last name is required'}]"
            ></app-formcontrol>
        </div>
    </div>
    <div class="row mb-1">
        <div class="col-md-4 col-lg-2 col-sm-12 mb-1">
            <label class="form-label">Email</label>
            <app-formcontrol
                [a-formcontrol]="form.controls.email"
                [a-formcontrol-name]="'email'"
                [a-validation-messages]="[{validationName: 'email', validationMessage: 'Email name is required'}]"
            ></app-formcontrol>
        </div>
    </div>
    <div class="row mb-1">
        <div class="col-md-4 col-lg-2 col-sm-12 mb-1">
            <label class="form-label">Phone</label>
            <app-formcontrol
                [a-formcontrol]="form.controls.primaryPhone"
                [a-formcontrol-name]="'primaryPhone'"
                [a-validation-messages]="[{validationName: 'required', validationMessage: 'Phone # is required'}]"
            ></app-formcontrol>
        </div>
    </div>
    <button type="submit" class="btn btn-primary btn-sm" [disabled]="form.invalid" [hidden]="employeeCreated">
        Add
    </button>
    <button type="submit" class="btn btn-primary btn-sm" [disabled]="form.invalid" [hidden]="!employeeCreated">
        Update
    </button>
</form>
